/**
 * 平台购物车
 */
import Glist from './data/Glist';
import store from '../index';
import { getConsumerOrderQueryCart, postConsumerOrderAddCart, postConsumerOrderRemoveCart, postConsumerOrderUpdateCart } from '@/api/order/cart';
import { postMemberLogin } from '@/api/user/login';
import { postConsumerOrderNew } from '@/api/order/order';
import CUser from '@/utils/User';

const Cart = {
	namespaced: true,
	state: {
		form: {
			isCheckedAll: true
		},
		list: Glist,

		cartList: [], //购物车列表
		allSelected: false, //购物车的全选状态
		cartNum: 0,

		hasPaperProduct: false //购物车是否包含纸质版商品
	},

	// 需要访问根状态来获取用户信息
	rootState: true,

	// 获取用户信息的方法
	getters: {
		// 判断是否为会员用户（levelId非0且levelEnd有效）
		isVipUser: (state, getters, rootState) => {
			const userInfo = rootState.User ? rootState.User.info : {};
			if (!userInfo) return false;

			// 检查levelId是否为非0
			const hasValidLevelId = userInfo.levelId && userInfo.levelId !== 0;

			// 检查levelEnd是否有效（大于当前时间）
			const now = new Date().getTime();
			const levelEndValid = userInfo.levelEnd && new Date(userInfo.levelEnd).getTime() > now;

			return hasValidLevelId && levelEndValid;
		},

		//获取购物车列表
		cartList: state => {
			return state.cartList;
		},

		//获取结算列表
		cartSettle: state => {
			// 先筛选出选中的商品
			const checkedItems = state.cartList.filter(info => info.isSelected);
			// 检查购物车是否包含纸质版商品（isDigit=0）
			state.hasPaperProduct = checkedItems.some(item => item.isDigit === 0);
			// console.log('checkedItems', checkedItems);
			// 按照 isDigit 进行分组
			const groupedByIsDigit = {};
			checkedItems.forEach(item => {
				const key = item.isDigit;
				if (!groupedByIsDigit[key]) {
					groupedByIsDigit[key] = [];
				}
				groupedByIsDigit[key].push(item);
			});

			// 转换为数组形式 [{isDigit: 0, list: [...]}, {isDigit: 1, list: [...]}]
			return Object.keys(groupedByIsDigit).map(key => ({
				isDigit: parseInt(key),
				list: groupedByIsDigit[key]
			}));

			// return state.cartList.filter(info => {
			//     return info.checked
			// })
		},

		// 实际价格合计（考虑会员价格）
		total(state, getters) {
			let t = 0;
			const isVip = getters.isVipUser;
			state.cartList.forEach(info => {
				if (info.checked) {
					// 如果是VIP用户且有VIP价格，使用VIP价格，否则使用普通价格
					const price = isVip && info.vipPrice ? info.vipPrice : info.salePrice;
					t += parseFloat(price * info.buyNum);
				}
			});
			return t;
		},

		// 合计多少金额
		allTotal(state) {
			let t = 0;
			state.cartList.forEach(info => {
				t += parseFloat(info.price);
			});
			return t;
		},

		// 原价合计
		oriTotal(state) {
			let t = 0;
			state.cartList.forEach(info => {
				if (info.checked) {
					t += parseFloat(info.fixedPrice * info.buyNum);
				}
			});
			return t;
		},

		// VIP合计
		vipTotal(state) {
			let t = 0;
			state.cartList.forEach(info => {
				if (info.checked) {
					t += parseFloat(info.vipPrice * info.buyNum);
				}
			});
			return t;
		},

		// 选中的数量
		checkedNum(state) {
			let num = 0;
			state.cartList.forEach(info => {
				if (info.checked) {
					num += info.buyNum;
				}
			});
			return num;
		},

		// 购物车中商品数量
		cartNum(state) {
			return state.cartList.length;
		},

		//总数量
		totalNum(state) {
			let n = 0;
			state.cartList.forEach(info => {
				if (info.isSelected) {
					n += info.buyNum;
				}
			});
			return n;
		},

		//被选中的商品总金额
		totalCheckedPrice(state) {
			let t = 0;
			state.cartList.forEach(info => {
				if (info.isSelected) {
					t += parseFloat(info.fixedPrice * info.buyNum);
				}
			});
			return t;
		},

		//被选中的商品总金额
		totalChecked(state, getters, rootState) {
			let t = 0;
			// 获取当前用户信息
			const userInfo = rootState.User ? rootState.User.info : {};
			const isVip = userInfo && userInfo.levelId > 0; // levelId > 0 表示VIP用户

			state.cartList.forEach(info => {
				if (info.isSelected) {
					// 如果是VIP用户且有VIP价格，使用VIP价格，否则使用普通价格
					const price = isVip && info.vipPrice ? info.vipPrice : info.salePrice;
					t += parseFloat(price * info.buyNum);
				}
			});
			return t;
		},

		//减少的价格
		reduceTotal(state, getters) {
			return getters.totalCheckedPrice - getters.totalChecked;
		},

		// 获取单个商品的显示价格（会员用户显示vipPrice，非会员显示salePrice）
		getDisplayPrice: (state, getters) => item => {
			const isVip = getters.isVipUser;
			const displayPrice = isVip && item.vipPrice ? item.vipPrice : item.salePrice;
			//console.log(`购物车 - 用户类型: ${isVip ? '会员用户' : '普通用户'}, 显示价格: ${displayPrice}, 会员价: ${item.vipPrice}, 普通价: ${item.salePrice}`);
			return displayPrice;
		},

		// 计算折扣率
		calculateDiscount: (state, getters) => item => {
			const displayPrice = getters.getDisplayPrice(item);
			const originalPrice = item.fixedPrice;

			// 检查价格是否有效
			if (!displayPrice || !originalPrice || originalPrice <= 0) {
				return null;
			}

			// 如果价格相同或显示价格大于等于原价，不显示折扣
			if (displayPrice >= originalPrice) {
				return null;
			}

			// 计算折扣率（保留一位小数）
			const discountRate = displayPrice / originalPrice;
			const roundedDiscount = parseFloat(discountRate.toFixed(2));

			// 如果折扣率大于等于1（即没有折扣），不显示
			if (roundedDiscount >= 1) {
				return null;
			}

			return roundedDiscount;
		}
	},

	//同步
	mutations: {
		['SET_CART_LIST'](state, cartList) {
			state.cartList = cartList;
		},

		['SET_CHECKED_ALL'](state) {
			state.cartList.forEach(item => {
				item.checked = true;
			});
		},

		['SET_NO_CHECKED_ALL'](state) {
			state.cartList.forEach(item => {
				item.checked = false;
			});
		},

		['SET_REMOVE_ITEM'](state, index) {
			state.cartList.splice(index, 1);
		},

		// 清空所有商品
		['SET_CLEAR_ALL'](state) {
			state.cartList = [];
		}
	},

	//异步
	actions: {
		//获取购物车数据
		getCartList({ commit }) {
			return new Promise((resolve, reject) => {
				getConsumerOrderQueryCart()
					.then(res => {
						let cartData = [];
						if (res.data !== null) {
							cartData = res.data.cartDetail;
							cartData.forEach(item => {
								item.checked = false;
							});
						}
						commit('SET_CART_LIST', cartData);
						resolve();
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//添加购物车
		addCart({ commit }, params) {
			// console.log('store', store.dispatch);
			return new Promise((resolve, reject) => {
				postConsumerOrderAddCart(params)
					.then(res => {
						//调用 获取购物车数据 方法
						store.dispatch('Cart/getCartList');
						resolve();
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//更新购物车
		modifyCart({ commit }, params) {
			return new Promise((resolve, reject) => {
				postConsumerOrderUpdateCart(params)
					.then(res => {
						store.dispatch('Cart/getCartList');
						resolve();
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//移除购物车
		removeCart({ commit }, params) {
			return new Promise((resolve, reject) => {
				postConsumerOrderRemoveCart(params)
					.then(res => {
						store.dispatch('Cart/getCartList');
						resolve();
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//提交订单
		submitOrder({ commit }, params) {
			return new Promise((resolve, reject) => {
				postConsumerOrderNew(params)
					.then(res => {
						store.dispatch('Cart/getCartList');
						resolve(res);
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		//全选
		checkAll({ commit }, params) {
			if (params) {
				commit('SET_CHECKED_ALL');
			} else {
				commit('SET_NO_CHECKED_ALL');
			}
		},

		// 清空所有商品
		clearAll({ commit }) {
			commit('SET_CLEAR_ALL');
		}
	}
};

export default Cart;
